import { Badge, Icon, Small } from "orcs-design-system";
import PropTypes from "prop-types";
import React from "react";

const PersistedMoveBadge = ({ group }) => {
  const hasPersistentMove = Boolean(group?.propertyOverrides?.directParent);

  if (!hasPersistentMove) {
    return null;
  }

  const label =
    group.hierarchyIds?.length >= 2
      ? "Persistently overridden"
      : "Persisted move";

  return (
    <Badge altStyle mt="xs" data-testid="cp-team-profile-header-persisted-move">
      <Icon icon={["far", "lock"]} size="sm" aria-hidden />
      <Small whiteSpace="nowrap">{label}</Small>
    </Badge>
  );
};

PersistedMoveBadge.propTypes = {
  group: PropTypes.object,
};

export default PersistedMoveBadge;
